// extracted by mini-css-extract-plugin
export default {"status":"Status_status__jJIVv","closed":"Status_closed__dA31A"};